/**
 * CsvFileDropzone component allows users to drag and drop a CSV file or click to upload one.
 * It uses the `react-dropzone` library to handle file drop and `detect-file-encoding-and-language`
 * to detect the file encoding before reading it as text.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.setFile - Callback function to set the file in the parent component.
 * @param {Function} props.fileOnLoadParameters - Callback function to handle file load parameters.
 *
 * @component
 * @example
 * const handleSetFile = (file) => { console.log(file); };
 * const handleFileOnLoad = (event) => { console.log(event.target.result); };
 * 
 * <CsvFileDropzone setFile={handleSetFile} fileOnLoadParameters={handleFileOnLoad} />
 */

import Typography from '@mui/material/Typography';
import { useState, useCallback } from 'react';
import { useDropzone } from "react-dropzone";
import languageEncoding from "detect-file-encoding-and-language"

export default function CsvFileDropzone({ setFile, fileOnLoadParameters, label }: any) {

  const [fileName, setFileName] = useState<File>();

  const fileReader = new FileReader();

  const onDrop = useCallback((acceptedFiles: File[]) => {
    var fileInit:File = acceptedFiles[0];

    setFileName(fileInit);
    setFile(fileInit);
    if (fileInit) {
      fileReader.onload = function (event) {
        fileOnLoadParameters(event);
    };

    languageEncoding(fileInit).then((fileInfo) => {
      const encoding = fileInfo.encoding === null ? 'windows-1252' : fileInfo.encoding;
      fileReader.readAsText(fileInit, encoding);
    });

    }
  }, [])

  const {
    getRootProps,
    getInputProps,
  } = useDropzone({accept: {'text/csv*': [".csv"]}, onDrop});

  return (
    <div {...getRootProps(
    {style :
        {display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '20px',
        borderWidth: 2,
        color: '#808080',
        borderColor: '#bdbdbd',
        borderStyle: 'dashed',
        outline: 'none',}
    })}>
    <input {...getInputProps()}/>
    {!fileName && (
        <Typography sx={{ mt: 2, mb: 1}}>
        {label}
        </Typography>
    )}
    {fileName && (
        <Typography sx={{ mt: 2, mb: 1}}>
        {fileName.name}
        </Typography>
    )}
    </div>
  );
}